import {FeatureLayerProperties, GRAPHIC_ATTRS, GRAPHIC_ATTR_IDS} from "../../models";
import {OBJECTID} from "../map";
import {MapLayerColor, MapTool} from "../../enums";
import {DibujoType} from "../../../../chacra-core/models";

export const ZONAS_LAYER: FeatureLayerProperties = {
  name: 'zonas-exclusion',
  title: 'Parche de Elevación',
  objectIdField: OBJECTID,
  geometryType: DibujoType.POLYGON,
  spatialReference: {wkid: 4326},
  outFields: ['*'],
  fields: [
    {name: 'graphicAttr', alias: 'Graphic Attr Type', type: 'string'},
    {name: 'featureName', alias: 'Feature Name', type: 'string'},
    {
      name: 'zonaExclusionId',
      alias: 'Parche de Elevación Id',
      type: 'string'
    },
    {name: 'chacraId', alias: 'Chacra Id', type: 'string'}
  ],
  renderer: {
    type: 'simple',
    symbol: {
      type: 'simple-fill',
      color: MapLayerColor.zonasExclusionFill,
      style: 'solid',
      outline: {
        type: 'simple-line',
        color: MapLayerColor.zonasExclusionOutline,
        width: '1px'
      }
    }
  },
  graphicAttr: GRAPHIC_ATTRS.ZONA_EXCLUSION,
  attrId: GRAPHIC_ATTR_IDS.ZONA_EXCLUSION,
  exportable: true,
  tools: [MapTool.polygon, MapTool.circle ]
};
